import { exec } from "@kakaopay-common/payweb-core";
import { INTERFACE } from "../../constants.mjs";
import { appendTiaraReferrer } from "../../utils/appendTiaraReferrer.mjs";
function openUrl(url = window == null ? void 0 : window.location.href, options) {
  const revisedUrl = (options == null ? void 0 : options.withTiaraReferrer) ? appendTiaraReferrer(url) : url;
  const command = {
    command: INTERFACE.OPEN_URL,
    parameters: {
      url: revisedUrl,
      ...(options == null ? void 0 : options.navigation) && { navigation: options.navigation },
      ...(options == null ? void 0 : options.post_body) && { post_body: options.post_body }
    }
  };
  return exec(command);
}
export {
  openUrl
};
